import React, {useContext} from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import BlockHeader from "component/BlockHeader/BlockHeader";
import { UserContext } from "..";
import { useState } from "react";
import fancybox from "component/Fancybox/Fancybox";
import { EditExperience } from "component/EditExperience";
import update from "immutability-helper";
import { useEffect } from "react";
import api from "api";
import _ from "lodash";
import { popinfo } from "component/Fancybox/Fancybox";
import { EditSkill, ProficiencyLevels } from "component/EditSkill";
import ThreeDots from "component/ThreeDots";
import "./index.scss";
import { PageCredential } from "component/PageCredential";

const PageProfileSkill = connect(stateMap)(props => {
    const currentUserContext = useContext(UserContext);
    const [skills, setSkills] = useState([]);
    const [skillload, setSkillLoad] = useState(true);

    const DeleteSkill = (Skill) => {
        let RemoveSkill = popinfo('loading', 'Removing Skill', '');

        api('/Profile/Skill', 'delete', {
            user_skill_id : Skill.UserSkillID
        }, 'Bearer ' + props.auth.token)
            .then(() => {
                RemoveSkill.close();

                setSkills(update(skills, {
                    $splice : [[
                        _.findIndex(skills, {UserSkillID : Skill.UserSkillID})
                        ,1
                    ]]
                }));
            })   
            .catch(error => {
                popinfo('error', 'Removing Skill', error, {}, RemoveSkill)
            })
    }

    const EditingSkill = (Skill) => {
        if(Skill)
        {
            const SkillForm = fancybox(
                <div className="w-640">
                    <BlockHeader title="Edit Skill" desc="Enter the skills you have for others to know more about your prowess, also tell your skill proficiency" className="mb-sm"/>
                    <EditSkill skill={Skill} onSubmit={skill => {
                        setSkills(update(skills, {
                            $splice : [[
                                _.findIndex(skills, {UserSkillID : skill.UserSkillID})
                                ,1
                                ,skill
                            ]]
                        }));

                        SkillForm.close();
                    }}/>
                </div>
            );
        }
        else
        {
            const SkillForm = fancybox(
                <div className="w-640">
                    <BlockHeader title="Add Skill" desc="Enter the skills you have for others to know more about your prowess, also tell your skill proficiency" className="mb-sm"/>
                    <EditSkill onSubmit={skill => {
                        setSkills(update(skills, {
                            $unshift : [skill]
                        }));

                        SkillForm.close();
                    }}/>

                </div>
            );
        }
    }
    

    useEffect(() => {
        if(!props.auth.user)
        {
            return;
        }

        setSkillLoad(true);

        api('/Profile/Skill', 'get', {
            user_id : props.auth.user.UserID
            ,posts_per_page : -1
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                setSkills(response.skill);

                setSkillLoad(false);
            })

        
    }, [props.auth.user]);


    
    return (
        <div className="profile-user-skills">
            <PageCredential title="My Skills" />
            <div className="container">
                <div className="w-640 mx-auto relative">
                    <BlockHeader title="Skills" desc="Tell everybody the best part of you"/>
                    <ul className="skills-list">
                        {
                            skills.map(skill => (
                                <li className="skill-wrapper relative" key={skill.UserSkillID}>
                                    <ThreeDots>
                                        <button onClick={ e => {
                                            e.preventDefault();

                                            EditingSkill(skill);
                                        }}>update</button>
                                        <button onClick={ e => {
                                            e.preventDefault();

                                            var ask = window.confirm('Are You Sure ?');

                                            if(!ask)
                                            {
                                                return;
                                            }

                                            DeleteSkill(skill);
                                        }}>delete</button>
                                    </ThreeDots>
                                    <div className="skill-list">
                                        <span className="skill-name bold text-sm mb-md block">{skill.SkillName}</span>
                                        <ProficiencyLevels proficiency={skill.Proficiency}/>
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                    {
                        !skillload &&
                        <button className="btn btn-reverse btn-small add-profile-item-button" onClick={(e) => {
                            e.preventDefault();
    
                            EditingSkill();
    
                        }}>Add Skill</button>
                    }
                </div>
            </div>
        </div>
    )
});

export default PageProfileSkill;